export const STATUS_UNAUTHORIZED = 401
export const STATUS_NOT_FOUND = 404

export const STATUS_INTERNAL_SERVER_ERROR = 500
